export const globalLoadingDispatch = (value: boolean) => {
  const event = new CustomEvent("globalLoading", {
    detail: { value },
  });
  window.dispatchEvent(event);
};

export const globalLayoutDispatch = (value: boolean) => {
  const event = new CustomEvent("globalLayout", {
    detail: { value },
  });
  window.dispatchEvent(event);
};
